import type { FC } from "react";

import { BulkImportContent } from "./BulkImportContent";

import { BulkImportType } from "components/server-types";
import { t } from "i18n/i18n";
import { Dialog } from "mds/components/Dialog";

interface BulkImportModalProps {
  importType: BulkImportType;
  open: boolean;
  onClose: () => void;
}

export const BulkImportModal: FC<BulkImportModalProps> = ({ importType, onClose, open }) => {
  return (
    <Dialog
      dialogPanelClassName="w-[598px]"
      open={open}
      title={open ? t(`home.settings.bulk_import_modal.types.${importType}`) : undefined}
      onClose={onClose}
    >
      <BulkImportContent importType={importType} onClose={onClose} />
    </Dialog>
  );
};
